import React from "react";
import { Link } from "gatsby";
import de from "date-fns/locale/de";
import format from "date-fns/format/index";
const SearchResult = _ref => {
    let { result } = _ref;
    return /*#__PURE__*/ React.createElement(Link, {
        to: result.slug,
        className: "block mb-8"
    }, /*#__PURE__*/ React.createElement("strong", {
        className: "font-medium underline text-xl block mb-1",
        dangerouslySetInnerHTML: {
            __html: result.title
        }
    }), "[...] ", result.text, " [...]", /*#__PURE__*/ React.createElement("div", {
        className: "mt-1"
    }, result.authors, result.authors && result.pubDate ? " | " : "", format(new Date(result.pubDate), "dd. MMMM yyyy", {
        locale: de
    })));
};
export default SearchResult;
